import BasicProfile from 'components/channel/BasicProfile';
import ChannelGrowth from 'components/channel/ChannelGrowth';
import ContentsData from 'components/channel/ContentsData';
import {
	Background,
	BodyInnerWrapper,
	BodyWrapper,
} from 'styles/styled-components/section';

const CreatorReport = () => {
	return (
		<Background>
			<BodyWrapper options={{ scrollbars: { autoHide: 'move', autoHideDelay: 250 } }}>
				<BodyInnerWrapper>
					<BasicProfile />
					<ChannelGrowth />
					<ContentsData />
				</BodyInnerWrapper>
			</BodyWrapper>
		</Background>
	);
};

export default CreatorReport;
